import { GtmTrackingType } from '../constants';
import TrackingHelperInstance from './gtmTrackingHelper';

class GtmImpulsiveBuyDelegator {
	constructor() {
		this.type = GtmTrackingType.IMPULSIVE_BUY;
		this.preventDefault = true;
		this.dataAttribute = 'data-gtm-tracking-type';
		this.isTest = false;
		this.eventCallbackHasFired = false;

		this.dataMapper = [
			{ dataName: 'data-product-name', gtmKey: 'name' },
			{ dataName: 'data-product-sku', gtmKey: 'id' },
			{ dataName: 'data-product-price-exc-vat', gtmKey: 'price' },
			{ dataName: 'data-product-brand', gtmKey: 'brand' },
			{ dataName: 'data-product-category', gtmKey: 'category' },
			{ dataName: 'data-product-variant', gtmKey: 'variant' },
			{ defaultValue: 1, gtmKey: 'position' },
			{ defaultValue: 1, gtmKey: 'quantity' },
		];
	}

	getTrackingData(target) {
		this.form = target.closest('form');

		const currentTarget =
			target.getAttribute(this.dataAttribute) === this.type
				? target
				: TrackingHelperInstance.findClosestClickableElement(
						target,
						this.dataAttribute,
						this.type,
					);

		const trackingData =
			currentTarget !== null
				? TrackingHelperInstance.getRequiredDataAsObject(
						currentTarget,
						this.dataMapper,
					)
				: null;

		return trackingData
			? this.generateDataLayerTrackingObject(trackingData)
			: trackingData;
	}

	generateDataLayerTrackingObject(trackingData) {
		return {
			event: 'addToCart',
			ecommerce: {
				add: {
					actionField: {
						list: TrackingHelperInstance.generateActionFieldString(),
					},
					products: [trackingData],
				},
			},
			eventCallback: this.callback.bind(this),
		};
	}

	callback() {
		if (this.form && !this.eventCallbackHasFired) {
			this.eventCallbackHasFired = true;
			this.form.submit();
		}
	}
}

const GtmImpulsiveBuyDelegatorInstance = new GtmImpulsiveBuyDelegator();
export default GtmImpulsiveBuyDelegatorInstance;

// for test purpose only
export const GtmImpulsiveBuyDelegatorClass = GtmImpulsiveBuyDelegator;
